import setDisplayName from 'recompose/setDisplayName';
import compose from 'recompose/compose';
import withHandlers from 'recompose/withHandlers';
import { connect } from 'react-redux';
import { PROMO_TYPE } from '../../main/settings/promoCodes/constants';
import AddPromoModal from '../components/AddPromoModal';
import { form } from '../../main/settings/promoCodes/Form';
import { addOwnerPromoCode } from '../../main/settings/promoCodes/actions';
import withActiveUserIdAndType from '../../common/hoc/withActiveUserIdAndType';
import withDateFormat from '../../auth/utils/withDateFormat';

const AddPromoModalContainer = compose(
  withActiveUserIdAndType(),
  setDisplayName('AddPromoModalContainer'),
  connect(
    () => ({
      initialValues: { oneTime: true, kind: PROMO_TYPE.amount },
    }),
    {
      addOwnerPromoCode,
    },
  ),
  withHandlers({
    onSubmit: props => data => props.addOwnerPromoCode(props.activeId, props.activeType, data).then(props.close),
  }),
  form,
  withDateFormat(),
)(AddPromoModal);

export default AddPromoModalContainer;
